export const positions = [
  'center', // Shown in the vertical and horizontal center of the screen.
  'h-center', // Shown in the horizontal center and top of the screen.
  'v-center', // Shown in the vertical center and left of the screen.
  'relative', // Relative to some other element on the screen, specified by the "relative" attribute.
  'manual', // Will be positioned manually by the developer using top/right/bottom/left coordinates. By default will be shown at top: 0, left: 0.
] as const;
export type Positions = (typeof positions)[number];

export const directions = [
  'auto', // Direction of expansion will be determined by a best guess method.
  'top-start', // Extends from the top and left side of the relative element.
  'top', // Extends from the top of the relative element in the horizontal center of that element.
  'top-end', // Extends from the top and right side of the relative element.
  'right-start',
  'right', // Extends from right side of the relative element in the vertical center of that element.
  'right-end',
  'bottom-end', // Extends from the bottom and right side of the relative element.
  'bottom', // Extends from the bottom of the relative element in the horizontal center of that element.
  'bottom-start', // Extends from the bottom and left side of the relative element.
  'left-end',
  'left', // Extends from right side of the relative element in the vertical center of that element.
  'left-start',
];
export type Directions = (typeof directions)[number];
